<template>
  <section class="not-found">
    <div>
      <img src="~@/assets/images/404-2x.png">
      <h2 v-t>Sorry, that page doesn't exist.</h2>
      <p>
        <span v-t>Like the penny, the page you're looking for isn't being used.</span>
        <a v-t :href="homeLink">Go back home</a>
        <span v-t> or </span>
        <a v-t onclick="window.Intercom('show')">contact us.</a>
      </p>
    </div>
  </section>
</template>

<script>

import '@/lib/icons/close';

export default {
  props: {
    homeLink: {
      type: String,
      default: '/',
    },
  },
};
</script>

<style lang="scss" scoped>


  .not-found {
    flex: 1 0 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: fit-content;
    padding: 3rem 0;

    > div {
      align-items: center;
      display: flex;
      flex-flow: column nowrap;
      margin: 0 1rem;

      img {
        max-width: 15rem;
      }

      h2 {
        margin-top: 2rem;
        text-align: center;
      }

      p {
        text-align: center;
        margin-top: 0.5rem;
        max-width: 26rem;
        > span, > a {
          margin-left: 4px;
        }
      }
    }
  }
</style>
